<template>
  <simple-scrollable-modal>
    <template #title>
      <span>Buscar dirección</span>
    </template>
    <template #content>
      <v-row>
        <v-col cols="12">
          <!--<v-text-field label="Dirección"
                        hide-details
                        v-model="editingBranch.address" outlined dense></v-text-field>-->
          <gmap-autocomplete
            v-if="fullPosition"
            class="introInput"
            :fields="['name', 'geometry.location']"
            @place_changed="onPlaceChanged"
          >
            <template v-slot:input="slotProps">
              <v-text-field
                outlined
                dense
                :label="$t('address')"
                :rules="$rule('required')"
                hide-details
                v-model="pos.address"
                ref="input"
                v-on:listeners="slotProps.listeners"
                v-on:attrs="slotProps.attrs"
              />
            </template>
          </gmap-autocomplete>
          <v-text-field
            v-else
            outlined
            dense
            :label="$t('address')"
            :rules="$rule('required')"
            hide-details
            v-model="pos.address"
            ref="input"
          />
          <v-text-field
            class="mt-3"
            outlined
            dense
            label="Piso, dpto..."
            hide-details
            v-model="pos.address2"
          />
          <v-textarea
            class="mt-3"
            outlined
            dense
            rows="2"
            label="Comentarios"
            hide-details
            v-model="pos.comments"
          />
        </v-col>
      </v-row>
      <div
        v-if="fullPosition"
        style="height: 350px; width: 100%; position: relative"
      >
        <l-map ref="myMap" :zoom="15" :center="mapCenter" @click="onMapClick">
          <l-tile-layer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <l-marker :lat-lng="pos" />
        </l-map>
        <v-btn
          color="info"
          small
          class="manual-position"
          v-if="!manualPositioning"
          @click="manualPositioning = true"
          depressed
          ><v-icon small class="mr-1">mdi-gesture-tap</v-icon>Ubicar
          manualmente</v-btn
        >
        <v-btn
          color="white"
          small
          class="manual-position"
          v-else
          @click="manualPositioning = false"
          depressed
          ><v-icon small class="mr-1">mdi-close</v-icon>Cancelar</v-btn
        >
        <span class="manual-position-note" v-if="manualPositioning"
          >Haga click donde quiera poner el marcador</span
        >
      </div>
    </template>
    <template #action-bar>
      <div class="d-flex flex-row align-center justify-space-between">
        <v-btn class="" depressed @click="$emit('close')"> Cancelar </v-btn>
        <div class="flex-fill text-right">
          <v-btn
            class="add-button"
            color="primary"
            depressed
            :disabled="(fullPosition && !pos.lat) || !pos.address"
            @click="save"
          >
            Guardar
          </v-btn>
        </div>
      </div>
    </template>
  </simple-scrollable-modal>
</template>

<script lang="ts">
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import SimpleScrollableModal from './base/SimpleScrollableModal.vue';
  import { debounce } from '../../utils';
  import {gmapApi} from 'gmap-vue/dist/gmap-vue';
  import { IBranch } from '../../interfaces/IBranch';

  @Component({
    components: { SimpleScrollableModal },
  })
  export default class AddressLookupModal extends Vue {
    $refs: {
      input: any;
    };
    @Prop() branch: IBranch;
    @Prop() fullPosition: boolean;

    address: string = null;
    autoCompleteService = null;
    placesService = null;
    //searchAddress: (address) => any;
    pos = {
      lat: null,
      lng: null,
      address: null,
      address2: null,
      comments: null,
    };
    manualPositioning = false;

    async created() {}

    mounted() {
      this.$refs.input.focus();
    }

    /*initLookup() {
    this.searchAddress = debounce((address) => {
      this.autoCompleteService.getQueryPredictions({ input: address }, (predictions, status ) => {
        if (!predictions || !predictions.length)
          return;

        const info = predictions[0];
        this.placesService.getDetails({ placeId: info.place_id, fields: ['geometry.location'] }, (place) => {
          this.pos.lat = place.geometry.location.lat();
          this.pos.lng = place.geometry.location.lng();
        })
      })
    }, 500);
  }*/

    onMapClick(event) {
      if (this.manualPositioning) {
        this.pos.lat = event.latlng.lat;
        this.pos.lng = event.latlng.lng;
        this.manualPositioning = false;
      }
    }

    onPlaceChanged(data) {
      if (!data) return;

      const address = this.pos.address;
      this.pos.address = data.name;
      this.pos.lat = data.geometry.location.lat();
      this.pos.lng = data.geometry.location.lng();
      this.pos.address = '';
      Vue.nextTick(() => {
        this.pos.address = address;
      });
    }

    save() {
      this.$parent.$emit('set', this.pos);
      this.$emit('close');
    }

    get mapCenter() {
      return {
        lat: this.pos.lat ?? this.branch.lat,
        lng: this.pos.lng ?? this.branch.lon,
      };
    }

    get gmap() {
      return gmapApi();
    }

    @Watch('gmap')
    gmapChanged(newVal, oldVal) {
      if (!oldVal && newVal) {
        this.autoCompleteService = new this.gmap.maps.places.AutocompleteService();
        this.placesService = new this.gmap.maps.places.PlacesService(
          document.createElement('div')
        );
      }
    }
  }
</script>
